import React from 'react';
import { UserRoles } from 'types';
import { useRoleAccess } from 'hooks/useRoleAccess';
import { Link } from 'react-router-dom';
import { NewButton } from 'components/Button/NewButton/NewButton';
import { Icon, IconName } from 'components/Icon/Icon';
import Text from 'components/Text/Text';

export const CreateBtn: React.FC = () => {
	const hasAccess = useRoleAccess([UserRoles.SUPER_USER]);

	return (
		<Link to={`/clients/customers${hasAccess ? '/create' : ''}`} data-test="CreateBtn">
			<NewButton iconLeft={<Icon name={IconName.plus} size="lg" />} disabled={!hasAccess}>
				<Text translationNameSpace="listing" translationKey="createClientButton" asFragment={true} />
			</NewButton>
		</Link>
	);
};
